// map on the position and return the same format as a geojson object
export const mapToGeoJSON = (geoJSONGeometry, callback) => {
  // check the type
  switch (geoJSONGeometry.type) {
    case "Point":
      return {
        ...geoJSONGeometry,
        coordinates: callback(geoJSONGeometry.coordinates),
      };

      break;
    case "Polygon":
      return {
        ...geoJSONGeometry,
        coordinates: [
          geoJSONGeometry.coordinates.map((el) => {
            return callback(el);
          }),
        ],
      };

    case "LineString":
      return {
        ...geoJSONGeometry,
        coordinates: geoJSONGeometry.coordinates.map((el) => {
          return callback(el);
        }),
      };
      break;
    default:
    // do nothing
  }
};
